import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { Container, Stack, Button, Table, Form, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { IngredientForm } from './IngredientForm';
import { CustomizedTypeahead } from './CustomizedTypeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import moment from "moment";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { userAuthContext } from './userAuthContext';
import { getIngredient, saveIngredient, recordHistory, getDocData, Ingredients, getIngredients } from '../data/IngredientData';
import ToggleButton from 'react-toggle-button';
import { Timestamp } from "firebase/firestore";
import { Settings, getSettings, documentToSettings } from '../data/SettingsData';
import { getReferenceName } from '../utils/ReferendeUtils';

export class IngredientList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      allDocs: [],
      ingredients: new Ingredients(),
      docRef: "",
      previousRef: "",
      isDeleteConfirmOpen: false,
      description: "",
      deleteDocRef: "",
      mode: "Add",
      showForm: false,
      didSave: true,
      show_deleted: false,
      settings: new Settings(),
    };
    
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.COLLECTION = "ingredients";

  }

  toggleShowForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      didSave: true,
    }, () => {
      this.readIngredientMaps(this.state.show_deleted);
    });

  }

  toggleMode = (mode) => {
    this.setState({
      docRef: "",
      mode: mode,
      showForm: true,
      didSave: false,
    });
  }


  toggleDeleteModal = (docRef, description) => {
    this.setState({
      deleteDocRef: docRef,
      description: description,
      isDeleteConfirmOpen: !this.state.isDeleteConfirmOpen,
    });
  }

  handleUpdate = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'Edit',
      didSave: false,
    });
  }

  handleDelete = async (docRef) => {
    let newHistoryList = new Array();
    let now = Timestamp.now();
    let ingredientDoc = await getIngredient(docRef);
    let ingredient = ingredientDoc.data();
    ingredient.is_deleted = !ingredient.is_deleted;
    newHistoryList = ingredient.history;
    let cost_changed = await recordHistory(newHistoryList, now, ingredient, docRef);
    ingredient.history = newHistoryList;

    let docData = getDocData(ingredient);

    await saveIngredient(this.state.settings,docRef, docData, cost_changed);
    this.readIngredientMaps(this.state.show_deleted);

  }

  toggleDeleteModal = (docRef, description) => {
    this.setState({
      deleteDocRef: docRef,
      description: description,
      isDeleteConfirmOpen: !this.state.isDeleteConfirmOpen,
    });
  };

 async loadSettings() {
    let docReference = getReferenceName(this.props.context.user.email);
    let tempSettingsDoc = await getSettings(docReference);
    let settings = documentToSettings(tempSettingsDoc);
    return settings;
  }

  async readIngredientMaps(show_deleted) {
    let ingredients = await getIngredients(show_deleted);
    let settings = await this.loadSettings();

    this.setState({
      ingredients: ingredients,
      settings: settings,
    });
  }

  componentDidMount() {
    this.readIngredientMaps();
    window.addEventListener('beforeunload', this.beforeunload.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.beforeunload.bind(this));
  }

  beforeunload(e) {
    if (!this.state.didSave) {
      e.preventDefault();
      e.returnValue = '';
    }
  }

  scrollToView(ref) {
    if (this.state.previousRef !== '' && this.state.previousRef.current) {
      let oldRef = this.state.previousRef;
      oldRef.current.style.background = 'white';
      this.setState({
        previousRef: "",
      })
    }
    setTimeout(() => {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      ref.current.style.background = 'gray';
      this.setState({
        previousRef: ref,
      })
    });
  }

  renderTableRow = (docRef, doc) => {
    let lastUpdatedString = "";
    if (doc.last_updated) {
      lastUpdatedString = moment(doc.last_updated.toDate()).format('MM/DD/YYYY HH:mm:ss');
    }
    let deleteText = "";
    let deleted = "";
    if (doc.is_deleted) {
      deleteText = "Undelete"
      deleted = "Y"
    } else {
      deleteText = "Delete"
      deleted = "N"
    }
    return (
      <tr key={docRef} ref={this.state.ingredients.refMap.get(docRef)}>
        <td>{doc.description}</td>
        <td>{doc.cost}</td>
        <td>{doc.per}</td>
        <td>{doc.total_price}</td>
        <td>{doc.total_quantity}</td>
        <td>{lastUpdatedString}</td>
        <td>{doc.information}</td>
        {this.state.show_deleted && <td show={this.state.show_deleted}>{deleted}</td>}
        <td>
          <DropdownButton variant="dark" id="dropdown-basic-button" title="Actions">
            <Dropdown.Item variant="dark" onClick={() => { this.handleUpdate(docRef) }}>Edit</Dropdown.Item>
            <Dropdown.Item variant="dark" onClick={() => { this.handleDelete(docRef) }}>{deleteText}</Dropdown.Item>
          </DropdownButton>
        </td>
      </tr>
    );

  }


  render() {

    let docMap = this.state.ingredients.docMap;

    return (
      <>
        {
          /* 
          * Ingredient List
          */
        }
        <Stack gap={3}>
          {!this.state.showForm &&
            <Container fluid>
              <Row className="justify-content-md-left">
                <Col>
                  <h2>Ingredients:</h2>
                </Col>
                <Col>
                  <Button variant="dark" onClick={() => { this.toggleMode('Add') }}>Add New Ingredient</Button>
                </Col>
                <Col>
                  <label htmlFor="show_deleted">Show Deleted?</label>
                  <ToggleButton
                    id="show_deleted"
                    inactiveLabel={'No'}
                    activeLabel={'Yes'}
                    value={this.state.show_deleted}
                    onToggle={(value) => {
                      this.setState({
                        show_deleted: !this.state.show_deleted,
                      }, () => {
                        this.readIngredientMaps(this.state.show_deleted);
                      })
                    }} />
                </Col>
                <Col md="auto">
                  Find:
                </Col>
                <Col md="auto">
                  <CustomizedTypeahead
                    onChange={(selected) => {
                      //console.log("selected" + selected);
                      if (selected.length > 0) {
                        let ref = this.state.ingredients.refMap.get(selected[0].id);
                        this.scrollToView(ref);
                      }
                    }}
                    id='ingredient_typeahead'
                    align='left'
                    labelKey={'value'}
                    options={this.state.ingredients.options}
                  />
                </Col>
              </Row>
            </Container>
          }
          {this.state.showForm &&
            <userAuthContext.Consumer>
              {context => (
                <IngredientForm
                  context={context}
                  docRef={this.state.docRef}
                  mode={this.state.mode}
                  toggleForm={() => { this.toggleShowForm() }}
                />
              )}
            </userAuthContext.Consumer>
          }
          <Modal
            className='modalDialog'
            isOpen={this.state.isDeleteConfirmOpen}
            onRequestClose={this.toggleModal}
            contentLabel="My dialog"
          >
            <div>
              Delete {this.state.description}?
            </div>
            <Button variant="dark" onClick={() => { this.toggleDeleteModal() }}>Cancel</Button>{' '}
            <Button variant="dark" onClick={() => { this.handleDelete(this.state.deleteDocRef) }}>Confirm</Button>
          </Modal>
          {!this.state.showForm &&
            <div className='scrollingTable'>
              <Table bordered hover>
                <thead>
                  <tr className='header'>
                    <th className='table-header'>Description</th>
                    <th className='table-header'>Cost</th>
                    <th className='table-header'>Per</th>
                    <th className='table-header'>Total Price</th>
                    <th className='table-header'>Total Quantity</th>
                    <th className='table-header'>Last Updated</th>
                    <th className='table-header'>Information</th>
                    {this.state.show_deleted && <th className='table-header'>Deleted?</th>}
                    <th className='table-header'></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...docMap].map(([key, value]) => {
                      return this.renderTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </div>
          }
        </Stack>
      </>
    );

  }
}